module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-pl.e5a6f0c0.mp4";